import { Component, OnInit } from '@angular/core';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { interval, Subscription } from 'rxjs';
import { map, retry, first } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { UploadcounterService } from '../uploadcounter.service';

@Component({
  selector: 'app-sync',
  templateUrl: './sync.component.html',
  styleUrls: ['./sync.component.css'],
})
export class SyncComponent implements OnInit {
  subscription: Subscription;
  current_db_id = 0;
  upload_total: any;

  constructor(
    private dbService: NgxIndexedDBService,
    private http: HttpClient, 
    private UploadcounterService: UploadcounterService,
  ) {}

  ngOnInit(): void {
    this.UploadcounterService.currentuploadTotal.subscribe(upload_total => this.upload_total = upload_total)
    
    const source = interval(5000);

    this.subscription = source.subscribe((val) => this.get_record());

    this.dbService.count('timingmobi').subscribe((peopleCount) => {
      this.UploadcounterService.changeUploadTotal(peopleCount);
    });
  }

  ngOnDestroy() {
    this.subscription && this.subscription.unsubscribe();
  }

  get_record() {
    this.dbService.count('timingmobi').subscribe((peopleCount) => {
      this.UploadcounterService.changeUploadTotal(peopleCount);

      console.log('Counter: '+peopleCount);

      if (peopleCount > 0) {
        this.dbService.getAll('timingmobi').subscribe((people) => {
          //console.log(JSON.stringify(people));
          //console.log(JSON.stringify(people[0]['id']));
     
          //console.log(people[0]);
          this.current_db_id = people[0]['id'];
          var json = people[0]['json'];
          //console.log(json);

          this.upload(json)
            .pipe(first())
            .subscribe({
              next: () => {
                this.dbService
                  .delete('timingmobi', this.current_db_id)
                  .subscribe(() => {
                    //console.log('all people:', allPeople);
                    this.dbService
                      .count('timingmobi')
                      .subscribe((peopleCount) => {
                        this.UploadcounterService.changeUploadTotal(peopleCount);
                      });
                  });
              },
              error: (error) => {
                console.log(error);
              },
            });
          
        });
      }
      
    });
  }

  upload(json: string) {
    return this.http
      .post<any>(`${environment.apiUrl}/upload.php`, {
        json,
      })
      .pipe(
        map((user) => {
          // store user details and jwt token in local storage to keep user logged in between page refreshes

          //alert(user.error)

          //alert(JSON.stringify(user));
          // var start_json_array=[];

          //start_json_array[mass_start_id]=[unix_time, localStorage.getItem('global_user_name')];
          //start_json_array[0]=[0, ''];
          // localStorage.setItem('global_start_json', JSON.stringify(start_json_array))
          //this.currentUserSubject.next(user);
          return user;
        }),
        retry(3)
      );
  }
}

//https://stackoverflow.com/questions/52671334/angular-6-run-a-function-in-every-x-seconds/52671432
